import { tabletQuery } from '@globals/themes/themeConstants'
import Close from '@mui/icons-material/Close'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import { styled } from '@mui/material/styles'
import { useT } from '@transifex/react'

export const DialogCloseButton = ({ onClose, id }: { onClose: () => void; id: string }) => {
  const t = useT()

  return (
    <Button
      aria-label={t('Close dialog button')}
      id={id}
      onClick={onClose}
      sx={{
        position: 'absolute',
        right: 18,
        top: 18,
      }}>
      <Close />
    </Button>
  )
}

export const DialogContentStyled = styled(DialogContent)({
  maxWidth: '100%',
  maxHeight: 'inherit',
  padding: '12px 24px',
})

export const DialogActionsStyled = styled(DialogActions)({
  padding: '16px 8px',
  '& > button:first-of-type': {
    marginRight: 8,
  },
})

export const DialogTitleImage = styled('img')({
  marginTop: 8,
  width: 190,
  height: 'auto',
  [tabletQuery]: {
    width: 125,
  },
})
